const alignmentClasses = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
};

export const shouldExpandActionsOnMobile = ({
  variant = 'task',
  expandChildrenOnMobile,
} = {}) => expandChildrenOnMobile ?? variant === 'task';

export const getActionGroupClasses = ({
  align = 'start',
  wrap = true,
  stackOnMobile = false,
  reverseOnMobile = false,
  expandChildrenOnMobile = false,
} = {}) => [
  'min-w-0',
  'gap-2',
  'flex',
  ...(stackOnMobile
    ? [
        reverseOnMobile ? 'flex-col-reverse' : 'flex-col',
        'sm:flex-row',
        wrap ? 'sm:flex-wrap' : 'sm:flex-nowrap',
      ]
    : [
        'items-center',
        wrap ? 'flex-wrap' : 'flex-nowrap',
      ]),
  ...(expandChildrenOnMobile
    ? ['[&>*]:w-full', 'sm:[&>*]:w-auto']
    : []),
  alignmentClasses[align] || alignmentClasses.start,
];
